// extracted by mini-css-extract-plugin
module.exports = {"CardsList":"cards-list_CardsList__229zy","Vertical":"cards-list_Vertical__w0_VM","PrimaryButton":"cards-list_PrimaryButton__YvDrz"};